import {Button, Icon, Issues} from '@bitstillery/common/components'
import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import {NotificationGroup} from '@bitstillery/common/components'
import {$t} from '@bitstillery/common/app'
import {$s, store} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

export class Support extends MithrilComponent {
    override oninit() {
        // Support.contact is now a computed signal in $s.store
        // It automatically updates when dependencies change
    }

    toggle_support(e: MouseEvent) {
        e.stopPropagation()
        $s.support.collapsed = !$s.support.collapsed
        void store.save()
    }

    view(): m.Children {
        return (
            <div
                className={classes('c-support', {
                    collapsed: $s.panels.left.collapsed || ['mobile', 'tablet'].includes($s.env.layout),
                    'collapsed-support': $s.support.collapsed,
                    toggleable: $s.env.layout === 'desktop',
                })}
            >
                {$s.support.collapsed && (
                    <Icon
                        className='support-icon'
                        name={'support'}
                        onclick={(e: MouseEvent) => this.toggle_support(e)}
                        size='l'
                        tip={$t._('support.contact.collapse')}
                        type='default'
                    />
                )}
                <div className='manager-contact-options'>
                    {$s.support.contact && (
                        <Button
                            icon='email'
                            onclick={() => {
                                const contact = $s.support.contact
                                if (contact?.email) {
                                    window.location.href = `mailto:${contact.email}`
                                }
                            }}
                            tip={$t._('support.contact.email', {contact: $s.support.contact.email})}
                            type='info'
                            variant='toggle'
                        />
                    )}

                    {process.env.MSI_PACKAGE === 'discover' && (
                        <Button
                            className='btn-expand'
                            icon='bug'
                            tip={$t('issues.label.title')}
                            type='info'
                            variant='toggle'
                            onclick={() => {
                                if ($s.issues) {
                                    $s.issues.collapsed = !$s.issues.collapsed
                                }
                            }}
                        />
                    )}

                    {process.env.MSI_PACKAGE === 'discover' && <Issues />}

                    {process.env.MSI_PACKAGE === 'portal' && $s.support.contact && (
                        <Button
                            icon='phone'
                            onclick={() => {
                                const contact = $s.support.contact
                                if (contact?.phone) {
                                    window.location.href = `tel:${contact.phone}`
                                }
                            }}
                            tip={$t._('support.contact.phone', {contact: $s.support.contact.phone})}
                            type='info'
                            variant='toggle'
                        />
                    )}

                    {$s.support.contact?.mobile && (
                        <Button
                            icon='cellPhone'
                            onclick={() => {
                                const mobile = $s.support.contact?.mobile
                                if (mobile) {
                                    window.location.href = `tel:${mobile}`
                                }
                            }}
                            tip={$t._('support.contact.mobile', {contact: $s.support.contact.mobile})}
                            type='info'
                            variant='toggle'
                        />
                    )}
                </div>

                <div className='manager-title' onclick={(e: MouseEvent) => this.toggle_support(e)}>
                    {!$s.support.collapsed && $s.env.layout !== 'mobile' && (
                        <Icon name={'chevronDown'} size='s' tip={$t._('support.contact.collapse')} type='info' />
                    )}
                    {process.env.MSI_PACKAGE === 'portal'
                        ? $t('support.contact.support_manager')
                        : $t('support.contact.tech_support')}
                </div>
                <div
                    className='manager-contact'
                    onclick={() => {
                        $s.panels.left.collapsed = !$s.panels.left.collapsed
                        void store.save()
                    }}
                    style={{'background-image': $s.support.contact?.img ? `url(${$s.support.contact.img})` : ''}}
                />
                <div className='manager-name'>{$s.support.contact?.name}</div>
                <NotificationGroup notifications={$s.notifications} />
            </div>
        )
    }
}
